import { render, staticRenderFns } from "./add_cookie_form.vue?vue&type=template&id=46e5d0e8"
import script from "./add_cookie_form.vue?vue&type=script&lang=js"
export * from "./add_cookie_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports